import React from 'react';
import Items, { defaultConfigComponent as ItemsConfig } from '../Items/Items';
import { IConfigComponent } from '@ts/ui-models';

export const defaultConfigComponent: IConfigComponent = {
  ...ItemsConfig,
  componentId: 'livestock',
  entity: 'livestock',
  filtersFetchData: { livestock: { isAlive: true } },
};
const Livestock = props => {
  const defaultProps = {
    flavorId: 'livestock',
    title: 'Livestock',
    nameColumns: ['defaultLocation', 'currentLocation', 'lastPosition'],
  };
  return <Items configComponent={defaultConfigComponent} {...defaultProps} {...props} />;
};

export default Livestock;
